import qs from 'qs';
import type { StateStorage } from 'zustand/middleware';

const hashStorage: StateStorage = {
  getItem: (key): string => {
    const searchParams = new URLSearchParams(location.hash.slice(1));
    const storedValue = searchParams.get(key) ?? '';
    return JSON.parse(storedValue);
  },
  setItem: (key, newValue): void => {
    const searchParams = new URLSearchParams(location.hash.slice(1));
    searchParams.set(key, JSON.stringify(newValue));
    location.hash = searchParams.toString();
  },
  removeItem: (key): void => {
    const searchParams = new URLSearchParams(location.hash.slice(1));
    searchParams.delete(key);
    location.hash = searchParams.toString();
  },
};

// const lzStorage: StateStorage = {
//   getItem: (key): string => {
//     const searchParams = new URLSearchParams(location.hash.slice(1));
//     const storedValue = searchParams.get(key);
//     if (!storedValue) return '';
//     const decompressed = decompressFromEncodedURIComponent(storedValue);
//     const finalValue = decompressed ? JSON.parse(decompressed) : '';
//     return finalValue;
//   },
//   setItem: (key, newValue): void => {
//     const searchParams = new URLSearchParams(location.hash.slice(1));
//     const compressed = compressToEncodedURIComponent(JSON.stringify(newValue));
//     searchParams.set(key, compressed);
//     location.hash = searchParams.toString();
//   },
//   removeItem: (key): void => {
//     const searchParams = new URLSearchParams(location.hash.slice(1));
//     searchParams.delete(key);
//     location.hash = searchParams.toString();
//   },
// };

const qsStorage: StateStorage = {
  getItem: (key): string => {
    const params = qs.parse(location.hash.slice(1));
    const value = params[key] as string;
    return value || '';
  },
  setItem: (key, newValue): void => {
    const current = qs.parse(location.hash.slice(1));
    current[key] = JSON.parse(JSON.stringify(newValue)); // ensure no circular refs
    const encoded = qs.stringify(current, {
      encode: false,
      arrayFormat: 'brackets',
    });
    location.hash = encoded;
  },
  removeItem: (key): void => {
    const current = qs.parse(location.hash.slice(1));
    delete current[key];
    const encoded = qs.stringify(current, {
      encode: false,
      arrayFormat: 'brackets',
    });
    location.hash = encoded;
  },
};

type StateSlice = 'global-state' | 'comment-filters' | 'job-filters' | 'record-filters';

function getDbTypeHashFragment(stateSlice: StateSlice = 'global-state', value: Record<string, any>): string {
  const state = { state: value, version: 0 };
  // if (qs) {
  //   const str = qs.stringify(
  //     { [stateSlice]: state },
  //     { encode: false, arrayFormat: "brackets" },
  //   );
  //   return `#${str}`;
  // }
  return `#${stateSlice}=${JSON.stringify(state)}`;
}

export { getDbTypeHashFragment, hashStorage, qsStorage };
